/* eslint-disable no-case-declarations */
import { get } from "lodash";
import * as types from "~/store/payment/paymentType";

const initialState = {
  loopStatus: false,
  loading: false,
  data: [],
  selectedMethod: {},
  methodId: "NO_PAYMENT",
  showModal: false,
  errors: {},
  price: {
    subTotal: 0,
    totalFee: 0,
    grandTotal: 0,
    priceOfSvAddOn: 0
  }
};

export default function allPaymnetMethod(state = initialState, action = {}) {
  switch (action.type) {
    case types.RESET_PAYMENT: {
      return { ...initialState };
    }

    case types.RESET_PRICE_PAYMENT:
      return {
        ...state,
        price: {
          ...state.price,
          priceOfSvAddOn: 0
        }
      };

    case types.UMC_GET_ALL_PAYMENT_METHODS:
      return {
        ...state,
        loading: true
      };

    case types.SET_PRICE_OF_SERVICE_ADD_ON:
      return {
        ...state,
        price: {
          ...state.price,
          priceOfSvAddOn: action.price
        }
      };
    case types.UMC_GET_ALL_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.data],
        price: {
          ...state.price,
          subTotal: action.data[0].subTotal,
          totalFee: 0,
          grandTotal: action.data[0].subTotal
        }
      };

    case types.GET_ALL_PAYMEN_MULTI_BOOKING_METHODS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.data],
        price: {
          ...state.price,
          subTotal: action.data[0].subTotal,
          totalFee: 0,
          grandTotal: action.data[0].subTotal
        }
      };

    case types.UMC_GET_ALL_PAYMENT_METHODS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors
      };
    case types.TOGGLE_MODAL_PAYMENT_METHOD:
      return {
        ...state,
        showModal: !state.showModal
      };
    case types.HIDE_MODAL_PAYMENT_METHOD:
      return {
        ...state,
        showModal: false
      };
    case types.SELECTED_PAYMENT_METHOD:
      const subTotal = get(action, "method.subTotal", 0);
      const totalFee = get(action, "method.totalFee", 0);
      const grandTotal = get(action, "method.grandTotal", 0);
      return {
        ...state,
        selectedMethod: { ...action.method },
        methodId: action.methodId,
        showModal: false,
        price: {
          ...state.price,
          subTotal: subTotal,
          totalFee,
          grandTotal: grandTotal
        }
      };
    case types.RESET_ALL_PROPS_PAYMENT_METHOD:
      return {
        ...state,
        selectedMethod: initialState.selectedMethod,
        methodId: initialState.methodId,
        loopStatus: false,
        price: {
          ...state.price,
          totalFee: 0,
          grandTotal: state.price.subTotal || 0
        }
      };

    case types.STOP_GET_STATUS_TRANSACTION:
      return {
        ...state,
        loopStatus: false
      };

    case types.ACTIVE_STATUS_TRANSACTION:
      return {
        ...state,
        loopStatus: true
      };

    default:
      return state;
  }
}
